export const supportCurrency = [
  'usd',
  'eur',
  'aud',
  'brl',
  'cad',
  'chf',
  'czk',
  'dkk',
  'gbp',
  'huf',
  'ils',
  'jpy',
  'mxn',
  'nok',
  'php',
  'pln',
  'sek',
  'myr',
  'inr',
  'cny',
  'uah',
  'idr',
  'try',
  'hkd',
  'twd',
  'ngn',
]

// 2023-11-30 各币种对美元汇率
export const currencyRate = [
  {
    currency: 'usd',
    rate: 1,
  },
  {
    currency: 'eur',
    rate: 1.098947,
  },
  {
    currency: 'aud',
    rate: 0.663114,
  },
  {
    currency: 'brl',
    rate: 0.203832,
  },
  {
    currency: 'cad',
    rate: 0.737109,
  },
  {
    currency: 'chf',
    rate: 1.146794,
  },
  {
    currency: 'czk',
    rate: 0.045226,
  },
  {
    currency: 'dkk',
    rate: 0.147306,
  },
  {
    currency: 'gbp',
    rate: 1.271368,
  },
  {
    currency: 'huf',
    rate: 0.002905,
  },
  {
    currency: 'ils',
    rate: 0.271455,
  },
  {
    currency: 'jpy',
    rate: 0.00681,
  },
  {
    currency: 'mxn',
    rate: 0.057863,
  },
  {
    currency: 'nok',
    rate: 0.093986,
  },
  {
    currency: 'php',
    rate: 0.018026,
  },
  {
    currency: 'pln',
    rate: 0.252968,
  },
  {
    currency: 'sek',
    rate: 0.096696,
  },
  {
    currency: 'myr',
    rate: 0.215127,
  },
  {
    currency: 'inr',
    rate: 0.011998,
  },
  {
    currency: 'cny',
    rate: 0.140809,
  },
  {
    currency: 'uah',
    rate: 0.027491,
  },
  {
    currency: 'idr',
    rate: 0.000065,
  },
  {
    currency: 'try',
    rate: 0.03459,
  },
  {
    currency: 'hkd',
    rate: 0.128107,
  },
  {
    currency: 'twd',
    rate: 0.032002,
  },
  {
    currency: 'ngn',
    rate: 0.000666,
  },
]

// 价格表的汇率换算
export const discount = 0.6
export const productPriceRate = [
  {
    currency: 'usd',
    rate: 1,
  },
  {
    currency: 'eur',
    rate: 0.93,
  },
  {
    currency: 'aud',
    rate: 1.56,
  },
  {
    currency: 'brl',
    rate: 4.88,
    discount,
  },
  {
    currency: 'cad',
    rate: 1.37,
  },
  {
    currency: 'chf',
    rate: 0.9,
  },
  {
    currency: 'czk',
    rate: 22.77,
  },
  {
    currency: 'dkk',
    rate: 6.95,
  },
  {
    currency: 'gbp',
    rate: 0.81,
  },
  {
    currency: 'huf',
    rate: 353.11,
    discount,
  },
  {
    currency: 'ils',
    rate: 3.9,
  },
  {
    currency: 'jpy',
    rate: 149.71,
  },
  {
    currency: 'mxn',
    rate: 17.49,
    discount,
  },
  {
    currency: 'nok',
    rate: 11.03,
  },
  {
    currency: 'php',
    rate: 55.88,
    discount,
  },
  {
    currency: 'pln',
    rate: 4.15,
    discount,
  },
  {
    currency: 'sek',
    rate: 10.88,
  },
  {
    currency: 'myr',
    rate: 4.66,
    discount,
  },
  {
    currency: 'inr',
    rate: 83.2,
    discount,
  },
  {
    currency: 'cny',
    rate: 7.27,
    discount,
  },
  {
    currency: 'uah',
    rate: 35.75,
    discount,
  },
  {
    currency: 'idr',
    rate: 15531.8,
    discount,
  },
  {
    currency: 'try',
    rate: 28.43,
  },
  {
    currency: 'hkd',
    rate: 7.81,
  },
  {
    currency: 'twd',
    rate: 31.5,
  },
  {
    currency: 'ngn',
    rate: 1500,
    discount,
  },
]

export const USACurrency = {
  country: 'United States',
  code: 'US',
  symbol: '$',
  iso: 'USD',
}

export const currency = [
  {
    country: 'India',
    code: 'IN',
    symbol: '₹',
    iso: 'INR',
  },
  {
    country: 'China',
    code: 'CN',
    symbol: '¥',
    iso: 'CNY',
  },
  USACurrency,
  {
    country: 'Indonesia',
    code: 'ID',
    symbol: 'Rp',
    iso: 'IDR',
  },
  {
    country: 'Pakistan',
    code: 'PK',
    symbol: '₨',
    iso: 'PKR',
  },
  {
    country: 'Nigeria',
    code: 'NG',
    symbol: '₦',
    iso: 'NGN',
  },
  {
    country: 'Brazil',
    code: 'BR',
    symbol: 'R$',
    iso: 'BRL',
  },
  {
    country: 'Bangladesh',
    code: 'BD',
    symbol: '৳',
    iso: 'BDT',
  },
  {
    country: 'Russia',
    code: 'RU',
    symbol: '₽',
    iso: 'RUB',
  },
  {
    country: 'Mexico',
    code: 'MX',
    symbol: '$',
    iso: 'MXN',
  },
  {
    country: 'Ethiopia',
    code: 'ET',
    symbol: 'Br',
    iso: 'ETB',
  },
  {
    country: 'Japan',
    code: 'JP',
    symbol: '¥',
    iso: 'JPY',
    noDivisionNeeded: true,
  },
  {
    country: 'Philippines',
    code: 'PH',
    symbol: '₱',
    iso: 'PHP',
  },
  {
    country: 'Egypt',
    code: 'EG',
    symbol: '£',
    iso: 'EGP',
  },
  {
    country: 'DR Congo',
    code: 'CD',
    symbol: 'Fr',
    iso: 'CDF',
  },
  {
    country: 'Vietnam',
    code: 'VN',
    symbol: '₫',
    iso: 'VND',
  },
  {
    country: 'Iran',
    code: 'IR',
    symbol: '﷼',
    iso: 'IRR',
  },
  {
    country: 'Turkey',
    code: 'TR',
    symbol: '₺',
    iso: 'TRY',
  },
  {
    country: 'Germany',
    code: 'DE',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Thailand',
    code: 'TH',
    symbol: '฿',
    iso: 'THB',
  },
  {
    country: 'United Kingdom',
    code: 'GB',
    symbol: '£',
    iso: 'GBP',
  },
  {
    country: 'Tanzania',
    code: 'TZ',
    symbol: 'Sh',
    iso: 'TZS',
  },
  {
    country: 'France',
    code: 'FR',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'South Africa',
    code: 'ZA',
    symbol: 'R',
    iso: 'ZAR',
  },
  {
    country: 'Italy',
    code: 'IT',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Kenya',
    code: 'KE',
    symbol: 'Sh',
    iso: 'KES',
  },
  {
    country: 'Myanmar',
    code: 'MM',
    symbol: 'Ks',
    iso: 'MMK',
  },
  {
    country: 'Colombia',
    code: 'CO',
    symbol: '$',
    iso: 'COP',
  },
  {
    country: 'South Korea',
    code: 'KR',
    symbol: '₩',
    iso: 'KRW',
  },
  {
    country: 'Uganda',
    code: 'UG',
    symbol: 'Sh',
    iso: 'UGX',
  },
  {
    country: 'Sudan',
    code: 'SD',
    symbol: 'ج.س.',
    iso: 'SDG',
  },
  {
    country: 'Spain',
    code: 'ES',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Argentina',
    code: 'AR',
    symbol: '$',
    iso: 'ARS',
  },
  {
    country: 'Algeria',
    code: 'DZ',
    symbol: 'د.ج',
    iso: 'DZD',
  },
  {
    country: 'Iraq',
    code: 'IQ',
    symbol: 'ع.د',
    iso: 'IQD',
  },
  {
    country: 'Afghanistan',
    code: 'AF',
    symbol: '؋',
    iso: 'AFN',
  },
  {
    country: 'Poland',
    code: 'PL',
    symbol: 'zł',
    iso: 'PLN',
  },
  {
    country: 'Canada',
    code: 'CA',
    symbol: '$',
    iso: 'CAD',
  },
  {
    country: 'Morocco',
    code: 'MA',
    symbol: 'د.م.',
    iso: 'MAD',
  },
  {
    country: 'Saudi Arabia',
    code: 'SA',
    symbol: '﷼',
    iso: 'SAR',
  },
  {
    country: 'Ukraine',
    code: 'UA',
    symbol: '₴',
    iso: 'UAH',
  },
  {
    country: 'Angola',
    code: 'AO',
    symbol: 'Kz',
    iso: 'AOA',
  },
  {
    country: 'Uzbekistan',
    code: 'UZ',
    symbol: 'Sʻ',
    iso: 'UZS',
  },
  {
    country: 'Yemen',
    code: 'YE',
    symbol: '﷼',
    iso: 'YER',
  },
  {
    country: 'Peru',
    code: 'PE',
    symbol: 'S/.',
    iso: 'PEN',
  },
  {
    country: 'Malaysia',
    code: 'MY',
    symbol: 'RM',
    iso: 'MYR',
  },
  {
    country: 'Ghana',
    code: 'GH',
    symbol: '₵',
    iso: 'GHS',
  },
  {
    country: 'Mozambique',
    code: 'MZ',
    symbol: 'MT',
    iso: 'MZN',
  },
  {
    country: 'Nepal',
    code: 'NP',
    symbol: 'रू',
    iso: 'NPR',
  },
  {
    country: 'Madagascar',
    code: 'MG',
    symbol: 'Ar',
    iso: 'MGA',
  },
  {
    country: 'Venezuela',
    code: 'VE',
    symbol: 'Bs.S.',
    iso: 'VES',
  },
  {
    country: 'Cameroon',
    code: 'CM',
    symbol: 'Fr',
    iso: 'XAF',
  },
  {
    country: 'Niger',
    code: 'NE',
    symbol: 'Fr',
    iso: 'XOF',
  },
  {
    country: 'Australia',
    code: 'AU',
    symbol: '$',
    iso: 'AUD',
  },
  {
    country: 'North Korea',
    code: 'KP',
    symbol: '₩',
    iso: 'KPW',
  },
  {
    country: 'Taiwan',
    code: 'TW',
    symbol: '$',
    iso: 'TWD',
  },
  {
    country: 'Mali',
    code: 'ML',
    symbol: 'Fr',
    iso: 'XOF',
  },
  {
    country: 'Burkina Faso',
    code: 'BF',
    symbol: 'Fr',
    iso: 'XOF',
  },
  {
    country: 'Syria',
    code: 'SY',
    symbol: '£',
    iso: 'SYP',
  },
  {
    country: 'Malawi',
    code: 'MW',
    symbol: 'MK',
    iso: 'MWK',
  },
  {
    country: 'Zambia',
    code: 'ZM',
    symbol: 'ZK',
    iso: 'ZMW',
  },
  {
    country: 'Romania',
    code: 'RO',
    symbol: 'lei',
    iso: 'RON',
  },
  {
    country: 'Chile',
    code: 'CL',
    symbol: '$',
    iso: 'CLP',
  },
  {
    country: 'Kazakhstan',
    code: 'KZ',
    symbol: '₸',
    iso: 'KZT',
  },
  {
    country: 'Chad',
    code: 'TD',
    symbol: 'Fr',
    iso: 'XAF',
  },
  {
    country: 'Ecuador',
    code: 'EC',
    symbol: '$',
    iso: 'USD',
  },
  {
    country: 'Somalia',
    code: 'SO',
    symbol: 'Sh',
    iso: 'SOS',
  },
  {
    country: 'Guatemala',
    code: 'GT',
    symbol: 'Q',
    iso: 'GTQ',
  },
  {
    country: 'Senegal',
    code: 'SN',
    symbol: 'Fr',
    iso: 'XOF',
  },
  {
    country: 'Netherlands',
    code: 'NL',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Cambodia',
    code: 'KH',
    symbol: '៛',
    iso: 'KHR',
  },
  {
    country: 'Guinea',
    code: 'GN',
    symbol: 'Fr',
    iso: 'GNF',
  },
  {
    country: 'Rwanda',
    code: 'RW',
    symbol: 'Fr',
    iso: 'RWF',
  },
  {
    country: 'Benin',
    code: 'BJ',
    symbol: 'Fr',
    iso: 'XOF',
  },
  {
    country: 'Burundi',
    code: 'BI',
    symbol: 'Fr',
    iso: 'BIF',
  },
  {
    country: 'Tunisia',
    code: 'TN',
    symbol: 'د.ت',
    iso: 'TND',
  },
  {
    country: 'Bolivia',
    code: 'BO',
    symbol: 'Bs.',
    iso: 'BOB',
  },
  {
    country: 'Haiti',
    code: 'HT',
    symbol: 'G',
    iso: 'HTG',
  },
  {
    country: 'Belgium',
    code: 'BE',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Jordan',
    code: 'JO',
    symbol: 'د.ا',
    iso: 'JOD',
  },
  {
    country: 'Dominican Republic',
    code: 'DO',
    symbol: 'RD$',
    iso: 'DOP',
  },
  {
    country: 'Cuba',
    code: 'CU',
    symbol: '$',
    iso: 'CUP',
  },
  {
    country: 'South Sudan',
    code: 'SS',
    symbol: '£',
    iso: 'SSP',
  },
  {
    country: 'Sweden',
    code: 'SE',
    symbol: 'kr',
    iso: 'SEK',
  },
  {
    country: 'Honduras',
    code: 'HN',
    symbol: 'L',
    iso: 'HNL',
  },
  {
    country: 'Czech Republic',
    code: 'CZ',
    symbol: 'Kč',
    iso: 'CZK',
  },
  {
    country: 'Azerbaijan',
    code: 'AZ',
    symbol: '₼',
    iso: 'AZN',
  },
  {
    country: 'Greece',
    code: 'GR',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Papua New Guinea',
    code: 'PG',
    symbol: 'K',
    iso: 'PGK',
  },
  {
    country: 'Portugal',
    code: 'PT',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Hungary',
    code: 'HU',
    symbol: 'Ft',
    iso: 'HUF',
  },
  {
    country: 'Tajikistan',
    code: 'TJ',
    symbol: 'с.',
    iso: 'TJS',
  },
  {
    country: 'United Arab Emirates',
    code: 'AE',
    symbol: 'د.إ',
    iso: 'AED',
  },
  {
    country: 'Belarus',
    code: 'BY',
    symbol: 'Br',
    iso: 'BYN',
  },
  {
    country: 'Israel',
    code: 'IL',
    symbol: '₪',
    iso: 'ILS',
  },
  {
    country: 'Togo',
    code: 'TG',
    symbol: 'Fr',
    iso: 'XOF',
  },
  {
    country: 'Austria',
    code: 'AT',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Switzerland',
    code: 'CH',
    symbol: 'Fr.',
    iso: 'CHF',
  },
  {
    country: 'Sierra Leone',
    code: 'SL',
    symbol: 'Le',
    iso: 'SLL',
  },
  {
    country: 'Laos',
    code: 'LA',
    symbol: '₭',
    iso: 'LAK',
  },
  {
    country: 'Hong Kong',
    code: 'HK',
    symbol: '$',
    iso: 'HKD',
  },
  {
    country: 'Serbia',
    code: 'RS',
    symbol: 'дин.',
    iso: 'RSD',
  },
  {
    country: 'Nicaragua',
    code: 'NI',
    symbol: 'C$',
    iso: 'NIO',
  },
  {
    country: 'Libya',
    code: 'LY',
    symbol: 'ل.د',
    iso: 'LYD',
  },
  {
    country: 'Paraguay',
    code: 'PY',
    symbol: '₲',
    iso: 'PYG',
  },
  {
    country: 'Kyrgyzstan',
    code: 'KG',
    symbol: 'с',
    iso: 'KGS',
  },
  {
    country: 'Bulgaria',
    code: 'BG',
    symbol: 'лв.',
    iso: 'BGN',
  },
  {
    country: 'Turkmenistan',
    code: 'TM',
    symbol: 'm.',
    iso: 'TMT',
  },
  {
    country: 'El Salvador',
    code: 'SV',
    symbol: '$',
    iso: 'USD',
  },
  {
    country: 'Republic of the Congo',
    code: 'CG',
    symbol: 'Fr',
    iso: 'XAF',
  },
  {
    country: 'Singapore',
    code: 'SG',
    symbol: '$',
    iso: 'SGD',
  },
  {
    country: 'Denmark',
    code: 'DK',
    symbol: 'kr',
    iso: 'DKK',
  },
  {
    country: 'Slovakia',
    code: 'SK',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Central African Republic',
    code: 'CF',
    symbol: 'Fr',
    iso: 'XAF',
  },
  {
    country: 'Finland',
    code: 'FI',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Norway',
    code: 'NO',
    symbol: 'kr',
    iso: 'NOK',
  },
  {
    country: 'Liberia',
    code: 'LR',
    symbol: '$',
    iso: 'LRD',
  },
  {
    country: 'Palestine',
    code: 'PS',
    symbol: '₪',
    iso: 'ILS',
  },
  {
    country: 'Lebanon',
    code: 'LB',
    symbol: 'ل.ل',
    iso: 'LBP',
  },
  {
    country: 'New Zealand',
    code: 'NZ',
    symbol: '$',
    iso: 'NZD',
  },
  {
    country: 'Costa Rica',
    code: 'CR',
    symbol: '₡',
    iso: 'CRC',
  },
  {
    country: 'Ireland',
    code: 'IE',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Mauritania',
    code: 'MR',
    symbol: 'UM',
    iso: 'MRU',
  },
  {
    country: 'Oman',
    code: 'OM',
    symbol: 'ر.ع.',
    iso: 'OMR',
  },
  {
    country: 'Panama',
    code: 'PA',
    symbol: 'B/.',
    iso: 'PAB',
  },
  {
    country: 'Kuwait',
    code: 'KW',
    symbol: 'د.ك',
    iso: 'KWD',
  },
  {
    country: 'Croatia',
    code: 'HR',
    symbol: 'kn',
    iso: 'HRK',
  },
  {
    country: 'Eritrea',
    code: 'ER',
    symbol: 'Nfk',
    iso: 'ERN',
  },
  {
    country: 'Georgia',
    code: 'GE',
    symbol: '₾',
    iso: 'GEL',
  },
  {
    country: 'Mongolia',
    code: 'MN',
    symbol: '₮',
    iso: 'MNT',
  },
  {
    country: 'Moldova',
    code: 'MD',
    symbol: 'L',
    iso: 'MDL',
  },
  {
    country: 'Uruguay',
    code: 'UY',
    symbol: '$',
    iso: 'UYU',
  },
  {
    country: 'Bosnia and Herzegovina',
    code: 'BA',
    symbol: 'KM',
    iso: 'BAM',
  },
  {
    country: 'Albania',
    code: 'AL',
    symbol: 'L',
    iso: 'ALL',
  },
  {
    country: 'Jamaica',
    code: 'JM',
    symbol: '$',
    iso: 'JMD',
  },
  {
    country: 'Armenia',
    code: 'AM',
    symbol: '֏',
    iso: 'AMD',
  },
  {
    country: 'Gambia',
    code: 'GM',
    symbol: 'D',
    iso: 'GMD',
  },
  {
    country: 'Lithuania',
    code: 'LT',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Qatar',
    code: 'QA',
    symbol: 'ر.ق',
    iso: 'QAR',
  },
  {
    country: 'Botswana',
    code: 'BW',
    symbol: 'P',
    iso: 'BWP',
  },
  {
    country: 'Namibia',
    code: 'NA',
    symbol: '$',
    iso: 'NAD',
  },
  {
    country: 'Gabon',
    code: 'GA',
    symbol: 'Fr',
    iso: 'XAF',
  },
  {
    country: 'Lesotho',
    code: 'LS',
    symbol: 'L',
    iso: 'LSL',
  },
  {
    country: 'Guinea-Bissau',
    code: 'GW',
    symbol: 'Fr',
    iso: 'XOF',
  },
  {
    country: 'Slovenia',
    code: 'SI',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'North Macedonia',
    code: 'MK',
    symbol: 'ден',
    iso: 'MKD',
  },
  {
    country: 'Latvia',
    code: 'LV',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Equatorial Guinea',
    code: 'GQ',
    symbol: 'Fr',
    iso: 'XAF',
  },
  {
    country: 'Trinidad and Tobago',
    code: 'TT',
    symbol: '$',
    iso: 'TTD',
  },
  {
    country: 'Bahrain',
    code: 'BH',
    symbol: '.د.ب',
    iso: 'BHD',
  },
  {
    country: 'Estonia',
    code: 'EE',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Mauritius',
    code: 'MU',
    symbol: '₨',
    iso: 'MUR',
  },
  {
    country: 'Cyprus',
    code: 'CY',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Eswatini',
    code: 'SZ',
    symbol: 'L',
    iso: 'SZL',
  },
  {
    country: 'Djibouti',
    code: 'DJ',
    symbol: 'Fr',
    iso: 'DJF',
  },
  {
    country: 'Fiji',
    code: 'FJ',
    symbol: '$',
    iso: 'FJD',
  },
  {
    country: 'Comoros',
    code: 'KM',
    symbol: 'Fr',
    iso: 'KMF',
  },
  {
    country: 'Guyana',
    code: 'GY',
    symbol: '$',
    iso: 'GYD',
  },
  {
    country: 'Bhutan',
    code: 'BT',
    symbol: 'Nu.',
    iso: 'BTN',
  },
  {
    country: 'Solomon Islands',
    code: 'SB',
    symbol: '$',
    iso: 'SBD',
  },
  {
    country: 'Macau',
    code: 'MO',
    symbol: 'MOP$',
    iso: 'MOP',
  },
  {
    country: 'Luxembourg',
    code: 'LU',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Montenegro',
    code: 'ME',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Suriname',
    code: 'SR',
    symbol: '$',
    iso: 'SRD',
  },
  {
    country: 'Cape Verde',
    code: 'CV',
    symbol: 'Esc',
    iso: 'CVE',
  },
  {
    country: 'Western Sahara',
    code: 'EH',
    symbol: 'د.ج',
    iso: 'DZD',
  },
  {
    country: 'Malta',
    code: 'MT',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Maldives',
    code: 'MV',
    symbol: '.ރ',
    iso: 'MVR',
  },
  {
    country: 'Brunei',
    code: 'BN',
    symbol: '$',
    iso: 'BND',
  },
  {
    country: 'Bahamas',
    code: 'BS',
    symbol: '$',
    iso: 'BSD',
  },
  {
    country: 'Belize',
    code: 'BZ',
    symbol: '$',
    iso: 'BZD',
  },
  {
    country: 'Iceland',
    code: 'IS',
    symbol: 'kr',
    iso: 'ISK',
  },
  {
    country: 'Vanuatu',
    code: 'VU',
    symbol: 'Vt',
    iso: 'VUV',
  },
  {
    country: 'French Polynesia',
    code: 'PF',
    symbol: '₣',
    iso: 'XPF',
  },
  {
    country: 'New Caledonia',
    code: 'NC',
    symbol: '₣',
    iso: 'XPF',
  },
  {
    country: 'Barbados',
    code: 'BB',
    symbol: '$',
    iso: 'BBD',
  },
  {
    country: 'Sao Tome and Principe',
    code: 'ST',
    symbol: 'Db',
    iso: 'STN',
  },
  {
    country: 'Samoa',
    code: 'WS',
    symbol: 'T',
    iso: 'WST',
  },
  {
    country: 'Saint Lucia',
    code: 'LC',
    symbol: '$',
    iso: 'XCD',
  },
  {
    country: 'Kiribati',
    code: 'KI',
    symbol: '$',
    iso: 'KID',
  },
  {
    country: 'Grenada',
    code: 'GD',
    symbol: '$',
    iso: 'XCD',
  },
  {
    country: 'Micronesia',
    code: 'FM',
    symbol: '$',
    iso: 'USD',
  },
  {
    country: 'Jersey',
    code: 'JE',
    symbol: '£',
    iso: 'JEP',
  },
  {
    country: 'Tonga',
    code: 'TO',
    symbol: 'T$',
    iso: 'TOP',
  },
  {
    country: 'Seychelles',
    code: 'SC',
    symbol: '₨',
    iso: 'SCR',
  },
  {
    country: 'Aruba',
    code: 'AW',
    symbol: 'ƒ',
    iso: 'AWG',
  },
  {
    country: 'Saint Vincent and the Grenadines',
    code: 'VC',
    symbol: '$',
    iso: 'XCD',
  },
  {
    country: 'Antigua and Barbuda',
    code: 'AG',
    symbol: '$',
    iso: 'XCD',
  },
  {
    country: 'Isle of Man',
    code: 'IM',
    symbol: '£',
    iso: 'IMP',
  },
  {
    country: 'Andorra',
    code: 'AD',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Dominica',
    code: 'DM',
    symbol: '$',
    iso: 'XCD',
  },
  {
    country: 'Cayman Islands',
    code: 'KY',
    symbol: '$',
    iso: 'KYD',
  },
  {
    country: 'Bermuda',
    code: 'BM',
    symbol: '$',
    iso: 'BMD',
  },
  {
    country: 'Guernsey',
    code: 'GG',
    symbol: '£',
    iso: 'GGP',
  },
  {
    country: 'Greenland',
    code: 'GL',
    symbol: 'kr',
    iso: 'DKK',
  },
  {
    country: 'Faroe Islands',
    code: 'FO',
    symbol: 'kr',
    iso: 'DKK',
  },
  {
    country: 'Saint Kitts and Nevis',
    code: 'KN',
    symbol: '$',
    iso: 'XCD',
  },
  {
    country: 'Turks and Caicos Islands',
    code: 'TC',
    symbol: '$',
    iso: 'USD',
  },
  {
    country: 'Sint Maarten',
    code: 'SX',
    symbol: 'ƒ',
    iso: 'ANG',
  },
  {
    country: 'Marshall Islands',
    code: 'MH',
    symbol: '$',
    iso: 'USD',
  },
  {
    country: 'Liechtenstein',
    code: 'LI',
    symbol: 'Fr.',
    iso: 'CHF',
  },
  {
    country: 'Monaco',
    code: 'MC',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'San Marino',
    code: 'SM',
    symbol: '€',
    iso: 'EUR',
  },
  {
    country: 'Gibraltar',
    code: 'GI',
    symbol: '£',
    iso: 'GIP',
  },
  {
    country: 'British Virgin Islands',
    code: 'VG',
    symbol: '$',
    iso: 'USD',
  },
  {
    country: 'Palau',
    code: 'PW',
    symbol: '$',
    iso: 'USD',
  },
  {
    country: 'Cook Islands',
    code: 'CK',
    symbol: '$',
    iso: 'CKD',
  },
  {
    country: 'Anguilla',
    code: 'AI',
    symbol: '$',
    iso: 'XCD',
  },
  {
    country: 'Nauru',
    code: 'NR',
    symbol: '$',
    iso: 'AUD',
  },
  {
    country: 'Wallis and Futuna',
    code: 'WF',
    symbol: '₣',
    iso: 'XPF',
  },
  {
    country: 'Tuvalu',
    code: 'TV',
    symbol: '$',
    iso: 'TVD',
  },
  {
    country: 'Montserrat',
    code: 'MS',
    symbol: '$',
    iso: 'XCD',
  },
  {
    country: 'Falkland Islands',
    code: 'FK',
    symbol: '£',
    iso: 'FKP',
  },
  {
    country: 'Niue',
    code: 'NU',
    symbol: '$',
    iso: 'NZD',
  },
  {
    country: 'Vatican City',
    code: 'VA',
    symbol: '€',
    iso: 'EUR',
  },
]

/**
 * 存在特殊币种,要进行特殊处理
 * 比如Apple的 JPY会 *1000, Stripe的JPY不会
 * 但对于美元, Apple和Stripe都会 *100
 *
 * 其他支付方式 TODO
 */
export function isZeroDecimalCurrencies(currency: string) {
  const currencyList = [
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'JPY',
    'KMF',
    'KRW',
    'MGA',
    'PYG',
    'RWF',
    'UGX',
    'VND',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
  ]
  return currencyList.includes(currency.toUpperCase())
}
